import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';
import { VerticalFlow } from '../../_layouts';
import Card from '../../_layouts/Card';
import Icon from '../Icon';

export const AlertIcon = styled.span`
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 99999px;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AlertContent = styled(VerticalFlow)`
  min-height: 36px;
  align-items: center;
`;

export const AlertBody = styled.div`
  ${mixin.text({ size: 200 })}
  color: var(--neutral-900);
  line-height: 1.2em;
`;

export const AlertFlow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 0.75rem;
`;

export const AlertContainer = styled(Card)`
  min-height: 60px;
  & > ${AlertFlow} {
    align-items: start;
    & > ${VerticalFlow} {
      align-content: center;
    }
  }

  ${({ color }) =>
    color &&
    css`
      ${AlertIcon} {
        background-color: var(--${color}-200);
        ${Icon} {
          color: var(--${color}-600);
        }
      }
    `}
`;
